export default "__VITE_PUBLIC_ASSET__6f71979e__"